import React from 'react';
import PropTypes from 'prop-types';

// shadcn/ui components
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { Alert, AlertDescription } from "components/ui/alert";

// Lucide icons
import { AlertCircle } from "lucide-react";

const Toolbar = ({ label, searchTerm, setSearchTerm, error }) => {
  return (
    <div className="space-y-2">
      {error && (
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      <div className="space-y-2">
        <Label htmlFor="search-input">{label}</Label>
        <Input
          id="search-input"
          type="text"
          value={searchTerm || ''}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder={`Search ${label}...`}
          className="w-full"
        />
      </div>
    </div>
  );
};

Toolbar.propTypes = {
  label: PropTypes.string,
  searchTerm: PropTypes.string,
  setSearchTerm: PropTypes.func,
  error: PropTypes.string,
};

export default Toolbar;
